import { createApp } from 'vue'
import App from './App.vue'
//提升css超过router，尝试解决safari布局错乱问题
import './assets/styles/index.scss'
import router from './router/index'
import store from './store/index'
import 'dayjs/locale/zh-cn'
import * as Icons from '@element-plus/icons-vue'
import ElementPlus from 'element-plus'
// 字体图标
import '@/assets/fonts/iconfont.css'
import '@/assets/fonts/iconfont'
// vxe-table 虚拟滚动表格
import VxeTable from 'vxe-table'
import 'vxe-table/lib/style.css'
import { initScreenConfig } from '@/config/screen'

initScreenConfig()

// let hasReloaded = false
const app = createApp(App)
app.use(store)
// 注册全局ICON
Object.keys(Icons).forEach(key => {
  app.component(key, Icons[key as keyof typeof Icons])
})

app.use(ElementPlus)
app.use(VxeTable)

app.use(router)

// 错误捕获
// window.addEventListener('unhandledrejection', event => {
//   const msg = event.reason?.message || ''
//   const isChunkError =
//     /dynamically imported module|Loading chunk|Failed to fetch/i.test(msg)
//   if (isChunkError && !hasReloaded) {
//     hasReloaded = true
//     location.reload()
//   }
// })
app.mount('#app')
